import { biLoggerFactory } from 'wix-private';
const msid = 'caf7956c-6104-4b0d-8fcb-65a0c1512fc6'; //replace the value between quotes with your site msid value
/**
* biGroupsLoggers it's an Object with key:value pair
* key: represents src of the BI group
* value: represents the biLogger function for that group
* */
const biGroupsLoggers = {
     19: biLoggerFactory('lp', 19, { msid }),
}
export async function fireBIEvent(src, evid, fields) {
   const biLogger = biGroupsLoggers[src];

   try {
       const biEventObject = {
           evid,
           ...fields
       };
       await biLogger.log(biEventObject);
       console.log('BI Event Fired, fields: ', biEventObject);
   } catch (err) {
       console.error(`Failed to fireBIEvent -err- ${err}`);
   }
}